import {Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {TaskOptionsService} from '../../../../services/task-options.service';
import {AlertService} from '../../../../services/notify/alert.service';
import {CrmService} from '../../../../services/api/crm.service';
import {ModalService} from '../../../../services/modal/modal.service';
import {TaskServiceService} from '../../../../services/task-service.service';
import {GraphServiceService} from '../../../../services/graph-service.service';
import {catchError, EMPTY, filter, from, Subscription, switchMap, tap} from 'rxjs';
import {StatusNodeModel} from '../../../../models/tasktable.model';
import {HelpersService} from '../../../../services/helpers.service';
import {MemberModel} from '../../../../models/user.model';
import {MemberService} from '../../../../services/member.service';
import {TranslateService} from '@ngx-translate/core';
import {
    BUSINESS_PROCESS_LAYER_ID,
    CONTRACT_LAYER_ID,
    DagreNodesOnlySettings,
    IKnUIOptions,
    IStageSettings,
    TIconsType,
    TLayerIDs
} from '../../../../modules/graph-konva/models/graph-kn.cm-api-models';
import { Node, Layout, IGraphNode } from '../../../../modules/graph-konva/models/graph-kn.model-interfaces';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DagreNodesOnlyLayout } from '../../../../modules/graph-konva/services/layout/dagreNodesOnly';
import { EdgePointerType, EEdgyType, ELayoutAlgorithms } from '../../../../modules/graph-konva/models/graph-kn.model-enums';
import { DialogsMTService, IconfirmDialogSettings } from '../../../../services/modal/dialogs-mt.service';
import { MatDialog } from '@angular/material/dialog';
import { AppTaskNodeCreateFormComponent } from '../forms/task-node-create-edit-form/task-node-create-edit-form';
import { AppTaskEdgeCreateFormComponent } from '../forms/task-node-create-edge-form/task-node-create-edge-form';

@Component({
    selector: 'app-task-statuses',
    templateUrl: './task-statuses.component.html',
    styleUrls: ['./task-statuses.component.scss']
})
export class TaskStatusesComponent implements OnInit, OnDestroy {
    public readonly parseInt = parseInt;

    @ViewChild('deleteStatusNode') public deleteStatusNode: TemplateRef<any>;

    @Input() boardAlias: string;

    @Input() activeStatus: number = null;
    isDeleteMode = false;
    sizes = [];
    public layout: Layout = new DagreNodesOnlyLayout();
    isShowIcons = false;
    color: string;

    isLockButton = false;

    subs: Subscription;

    allMembers: MemberModel[];
    tab = 'option'; // 'option' | 'members'
    roleType = ''; // 'executor' | 'responsible' | 'observer'
    public nodesWithoutArchive: IGraphNode[] = []
    public layoutDagreSettings: Map<TLayerIDs, DagreNodesOnlySettings> = new Map([
			[BUSINESS_PROCESS_LAYER_ID,	{   
        //ELK 
        module:ELayoutAlgorithms.ELK,  
				algorithmEdges:ELayoutAlgorithms.ELK,
				edgeType:EEdgyType.Dagre,
				pointerType:EdgePointerType.Arrow,
				ranker: 'layered',

        //DAGRE
/*         module:ELayoutAlgorithms.Darge,  
				algorithmEdges:ELayoutAlgorithms.Darge,
				edgeType:EEdgyType.Dagre,
				pointerType:EdgePointerType.Arrow,
				ranker: 'network-simplex', */

				rankPadding: 80,
				nodePadding: 50,  
				marginX: 50,
				marginY: window.innerHeight * 0.0,
				heigt: window.innerHeight ,
				width: window.innerWidth -100,
        nodeWidthAdaptive:false
			}]
    ])
    public stageSettings: IStageSettings = {
        offsetY: -5,
        height: window.innerHeight * 2,
        width: window.innerWidth * 2,
        showSettingsButton:true,
    }
    public graphUISetting: Map<TLayerIDs, IKnUIOptions> = new Map([
        [CONTRACT_LAYER_ID, {}],
        [BUSINESS_PROCESS_LAYER_ID, {
            draggable:true,
            showDetails: true,
            showUsers: true,
            showStatusPanel: true,
            showEdit: true,
            showDelete: true,
            showCreateNode: true,
            showCreateEdge: true,
            showDeleteEdge: true
        }]
    ])

    constructor(
        public taskOptionsService: TaskOptionsService,
        public alert: AlertService,
        public crmService: CrmService,
        public modalService: ModalService,
        public taskService: TaskServiceService,
        public graphService: GraphServiceService,
        public helper: HelpersService,
        public memberService: MemberService,
        private translate: TranslateService,
        private dialogsMTService:DialogsMTService,
        private dialog:MatDialog
    ) {
    }

    ngOnInit(): void {
        if (this.taskOptionsService.selectedBoard && !this.boardAlias) {
            this.graphService.selectBoard(this.taskOptionsService.selectedBoard, false);
        } else if (this.boardAlias) {
            this.taskOptionsService.onLoadBoardOptions(this.boardAlias, true);
        }

        this.subs = this.taskOptionsService.emitChangeBoard.subscribe((board) => {
            this.graphService.deleteStatusNode = this.deleteStatusNode;
            this.graphService.selectBoard(board, false);
        });

        this.memberService.getAllMembers().then(res => {
            this.allMembers = res;
        });
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    handleNodeEvent(event: { action: TIconsType, data: IGraphNode }) {
        this.nodesWithoutArchive = this.graphService.nodes.filter(x => !x.bp_status_data?.is_archive && !x.bp_status_data?.is_universal);
        switch (event.action) {
            case 'ADD_EDGE':
                let edgeFormRef = this.dialog.open(AppTaskEdgeCreateFormComponent)  
                edgeFormRef.componentInstance.source_id = event.data.id
                break;
            case 'ADD_NODE':
                let formRefAdd = this.dialog.open(AppTaskNodeCreateFormComponent)  
                let linkedDataAdd = this.graphService.getLinkedStatues(event.data)
                formRefAdd.componentInstance.linkedStatuses = {in:[event.data],out:[]};
                formRefAdd.componentInstance.linkedEdges = linkedDataAdd.edges;
                formRefAdd.componentInstance.availableStatuses = this.graphService.getAvailableStatuses(event.data, true);
                formRefAdd.componentInstance.allMembers = this.allMembers  
                
                break;
            case 'EDIT_NODE':
                let formRef = this.dialog.open(AppTaskNodeCreateFormComponent)
                formRef.componentInstance.formMode = 'Edit' 
                formRef.componentInstance.allMembers = this.allMembers  
                let linkedData = this.graphService.getLinkedStatues(event.data)
                formRef.componentInstance.linkedStatuses = linkedData.statuses;
                formRef.componentInstance.linkedEdges = linkedData.edges;
                formRef.componentInstance.availableStatuses = this.graphService.getAvailableStatuses(event.data);
                formRef.componentInstance.nodeData = event.data
                break;
            case 'DELETE_NODE':
               this.deleteElement(event.data, true)
                break;
        }
    }

    deleteElement(event: IGraphNode, isNode: boolean) {
		let dialogSettings:IconfirmDialogSettings = {
			actionHeader: 'CONFIRM.HEADERS.DELETE',
			actionBody: isNode ? 'CONFIRM.TEXT.DELETE_STEP' : 'CONFIRM.TEXT.DELETE_LINK'
		}
		this.dialogsMTService.confirmDialog(dialogSettings)
		.pipe(
			filter(res => res.isConfirmed),
			switchMap(() => from(this.graphService.deleteGraphElement(isNode, event))),
			catchError(() => {
				return EMPTY
			}))
        .subscribe() 
    }

    onDeleteStatus(statusName: string, modal: NgbModalRef): void {
        if (statusName !== this.graphService.deleteStatus.label) {
            return this.alert.setAlert(this.translate.instant('ALERTS.DELETE_STATUS_NAME'), 'blue');
        }

        this.isLockButton = true;
        this.crmService.deleteNode(
            this.graphService.deleteStatus.id,
            this.graphService.selectedStatus.id
        ).subscribe({
            next: res => {
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                void this.graphService.selectBoard(res.board, true);
                this.isLockButton = false;
                modal.close();
            }, error: error => {
                this.isLockButton = false;
                this.alert.setAlert(error.message, 'blue');
            }
        });
    }
}
